import { render, staticRenderFns } from "./AssignCourseModal.vue?vue&type=template&id=63c50bea&scoped=true&"
import script from "./AssignCourseModal.vue?vue&type=script&lang=js&"
export * from "./AssignCourseModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignCourseModal.vue?vue&type=style&index=0&id=63c50bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c50bea",
  null
  
)

export default component.exports